"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * Warning icon - represents warning or error states.
 * Used in import errors and alert messages.
 */
var Warning = function Warning(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M0.666992 14H15.3337L8.00033 1.33331L0.666992 14ZM8.66699 12H7.33366V10.6666H8.66699V12ZM8.66699 9.33331H7.33366V6.66665H8.66699V9.33331Z",
    fill: "currentColor"
  }));
};

var _default = Warning;
exports.default = _default;